import { LinkItem } from "@dirootie-web/elements-types";
import { Widget } from "./Widget";
import { WidgetQuickActionsProps } from "./Widgets.types";
import { Link } from "react-router-dom";
import { splitAndCapitalize } from "../../components-domain/generation-domain/configurations/steps/3-building-components/BuildingComponents";

export const QuickActionLink: React.FC<any> = ({ to, id, label }: LinkItem) => {
  return (
    <Link to={to} key={id}>
      {splitAndCapitalize(label as string)}
    </Link>
  );
};

export const QuickActionListItem: React.FC<any> = ({
  id,
  label,
  ...rest
}: LinkItem) => (
  <li key={`${id!}-${label}`}>
    <QuickActionLink key={`item-${id!}-${label}`} {...{ ...rest, id, label }} />
  </li>
);

export const WidgetQuickActions = ({
  items = [],
  id,
  ...rest
}: WidgetQuickActionsProps) => (
  <Widget {...rest} key={id}>
    <ul key={`ul-${id!}`} className="list-styled">
      {items.map((x) => {
        if (typeof x === "string") {
          return <QuickActionListItem key={x} {...quickActionsDefaults[x]} />;
        }
        return <QuickActionListItem key={x.id} {...x} />;
      })}
    </ul>
  </Widget>
);

const quickActionsDefaults: any = {
  create_course: {
    id: "create_course",
    to: "/courses/new",
    label: "Create new course",
  },
  create_building_config: {
    id: "create_building_config",
    to: "/building-configurations/new",
    label: "Create new building configuration",
  },
  create_space_function: {
    id: "create_space_function",
    to: "/components-db/data/space-functions/spaces/new",
    label: "Create new space function",
  },
  create_floor_type: {
    id: "create_floor_type",
    to: "/components-db/components/floors/types/new",
    label: "Create new floor type",
  },
  create_wall_type: {
    id: "create_wall_type",
    to: "/components-db/components/walls/types/new",
    label: "Create new wall type",
  },
  create_window_type: {
    id: "create_window_type",
    to: "/components-db/components/windows/types/new",
    label: "Create new window type",
  },
  create_roof_type: {
    id: "create_roof_type",
    to: "/components-db/components/roofs/types/new",
    label: "Create new roof type",
  },
};
